module.exports = __webpack_public_path__ + "static/media/clock-white.68cca0ab.svg";